/* @flow */

import { createSelector } from '@reduxjs/toolkit';

/*
|------------------------------------------------------------------------------
| INPUTS
|------------------------------------------------------------------------------
*/

const _segment = (state) => state.app.support.retrieveEmail;

const _getRetrieveEmailRequest = (state) => _segment(state).isFetching;
const _getRetrieveEmailFailure = (state) => _segment(state).failure;
const _isUsernameRetrieved = (state) => _segment(state).success;
const _getRetrievedUsername = (state) => _segment(state).username;
const _getRetrievedMembership = (state) => _segment(state).membership_id;

/*
|------------------------------------------------------------------------------
| SELECTORS
|------------------------------------------------------------------------------
*/

export const getRetrieveEmailRequest: (
  state: Object,
) => boolean = createSelector(
  [_getRetrieveEmailRequest],
  (x: boolean): boolean => x,
);

export const hasUsernameRetrievalFailed: (
  state: Object,
) => Error = createSelector([_getRetrieveEmailFailure], (x: Error): Error => x);

export const isUsernameRetrieved: (state: Object) => boolean = createSelector(
  [_isUsernameRetrieved],
  (x: boolean): boolean => x,
);

export const getRetrievedUsername: (state: Object) => string = createSelector(
  [_getRetrievedUsername],
  (x: string): string => x,
);

export const getRetrievedMembership: (state: Object) => number = createSelector(
  [_getRetrievedMembership],
  (x: number): number => x,
);
